/* eslint-disable no-use-before-define */

/* eslint-disable no-unused-vars */

/* eslint-disable @typescript-eslint/no-unused-vars */
import React from "react";
import {
  Animated,
  StyleProp,
  ViewStyle,
  TextStyle,
} from "react-native";
import SVG_Svg, {
  G as SVG_G,
  Path as SVG_Path,
  GProps,
  PathProps,
} from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: desc */

/***/

const Path = Animated.createAnimatedComponent<
  React.ComponentClass<
    PathProps & {
      style?: StyleProp<ViewStyle>;
    }
  >
>(SVG_Path);
const G = Animated.createAnimatedComponent<
  React.ComponentClass<
    GProps & {
      style?: StyleProp<ViewStyle>;
    }
  >
>(SVG_G);
const Svg = Animated.createAnimatedComponent(SVG_Svg);

/*
 * -------------------------------------------------------------------------
 *
 *  /$$$$$$                                /$$$$$$$  /$$
 * |_  $$_/                               | $$__  $$| $$
 *   | $$   /$$$$$$/$$$$   /$$$$$$        | $$  \ $$| $$ /$$   /$$  /$$$$$$
 *   | $$  | $$_  $$_  $$ /$$__  $$       | $$$$$$$ | $$| $$  | $$ /$$__  $$
 *   | $$  | $$ \ $$ \ $$| $$  \ $$       | $$__  $$| $$| $$  | $$| $$$$$$$$
 *   | $$  | $$ | $$ | $$| $$  | $$       | $$  \ $$| $$| $$  | $$| $$_____/
 *  /$$$$$$| $$ | $$ | $$| $$$$$$$/  /$$  | $$$$$$$/| $$|  $$$$$$/|  $$$$$$$
 * |______/|__/ |__/ |__/| $$____/  |__/  |_______/ |__/ \______/  \_______/
 *                       | $$
 *                       | $$
 *                       |__/
 *
 * -------------------------------------------------------------------------
 *
 * ORIGINAL SVG
 * ---------------------------------
 * <svg width="18" height="13" viewBox="0 0 18 13" fill="none" xmlns="http://www.w3.org/2000/svg"> <desc id="IMP.BLUE"></desc>
 * <g id="HamburgerIcon">
 * <rect id="Rectangle 306" width="18" height="0.906977" fill="#373938"/>
 * <rect id="Rectangle 307" y="6.04651" width="13.2" height="0.906977" fill="#373938"/>
 * <rect id="Rectangle 308" y="12.093" width="18" height="0.906977" fill="#373938"/>
 * </g>
 * </svg>
 *
 * ---------------------------------
 *
 * CONFIGURATION
 * ---------------------------------
 * {}
 * ---------------------------------
 *
 * DESCRIPTION
 * ---------------------------------
 * No description provided!
 * ---------------------------------
 */

/** Component Properties Interface */
export type tProps = {
  style?: tStyle;
  svgStyle?: tStyle;
  isInsideScrollView?: boolean;
  svgRef?: () => void;
  onAnimationComplete?: () => void;
};
/***/

/***/

export type tStyle = StyleProp<ViewStyle>;
export type tTextStyle = StyleProp<TextStyle>;
/***/

/***/

/**
 * Auto-Generated Imp.Blue Component based on your design!
 * @param {tProps} props Developer interface to the component!
 * @returns {JSX.Element} JSX
 *
 * Description --
 * No description provided!
 */

export const HamburgerIcon = (props: {
  style?: tStyle;
  svgStyle?: tStyle;
  isInsideScrollView?: boolean;
  svgRef?: () => void;
  onAnimationComplete?: () => void;
}): JSX.Element => {
  const {
    svgRef,
  } = props;
  /** End Custom React-Hooks */

  /** Component Render (Javascript-React Markup) */

  return (
    <Svg viewBox="0 0 18 13" fill="none" id="svg_root" ref={svgRef} {...props}>
      <G id="HamburgerIcon">
        <Path
          id="Rectangle_20306"
          fill="#373938"
          d="M0 0 H18 a0,0 0 0 1 0,0 V0.906977 a0,0 0 0 1 -0,0 H0 a0,0 0 0 1 -0,-0 V0 a0,0 0 0 1 0,-0z"
          strokeWidth="1"
          vectorEffect="non-scaling-stroke"
        />
        <Path
          id="Rectangle_20307"
          fill="#373938"
          d="M0 6.04651 H13.2 a0,0 0 0 1 0,0 V6.953487 a0,0 0 0 1 -0,0 H0 a0,0 0 0 1 -0,-0 V6.04651 a0,0 0 0 1 0,-0z"
          strokeWidth="1"
          vectorEffect="non-scaling-stroke"
        />
        <Path
          id="Rectangle_20308"
          fill="#373938"
          d="M0 12.093 H18 a0,0 0 0 1 0,0 V12.999977 a0,0 0 0 1 -0,0 H0 a0,0 0 0 1 -0,-0 V12.093 a0,0 0 0 1 0,-0z"
          strokeWidth="1"
          vectorEffect="non-scaling-stroke"
        />
      </G>
    </Svg>
  );
};
/***/

export default React.memo(HamburgerIcon);
